/**
 * Locale is pinned to ja-JP rather than driven by the UI language: the value is
 * a record timestamp that appears alongside Japanese engineering paperwork.
 */
export const formatSessionDate = (dateString?: string): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};
